import React from 'react';
import SvgIcon from './SvgIcon';

const EventState = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.414 13.414a2 2 0 01-2.828-2.828c.78-.781 8.132-5.3 8.132-5.3s-4.518 7.347-5.304 8.128zM3.5 12H5M5.99 5.99l1.06 1.06M12 3.5V5M20.5 12H19M20.633 19.6A14.707 14.707 0 0012 17a14.707 14.707 0 00-8.633 2.6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

EventState.displayName = 'EventStateIcon';

export default EventState;
